import React from 'react';
import { BookingButton } from '../components/BookingButton';
import { ProviInfographic } from '../components/ProviInfographic';
import { OfferCard } from '../components/OfferCard';
import { TestimonialCard } from '../components/TestimonialCard';
import { FooterCTA } from '../components/FooterCTA';
import { testimonials } from '../components/testimonials';
export function Home() {
  return <div className="w-full min-h-screen bg-[#F1F5F9] overflow-x-hidden pt-20" data-id="element-346">
      {/* SECTION 1 — HERO */}
      <section className="w-full bg-[#09111F] relative overflow-hidden" data-id="element-347">
        {/* Decorative Background Elements */}
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-348"></div>
        <div className="absolute top-[-120px] right-[-120px] w-[500px] h-[500px] rounded-full bg-[#1D4ED8] opacity-20 blur-[80px]" data-id="element-349"></div>
        <div className="absolute bottom-[-80px] left-[-100px] w-[300px] h-[300px] rounded-full bg-[#3B82F6] opacity-10 blur-[60px]" data-id="element-350"></div>

        <div className="max-w-[1200px] mx-auto px-5 md:px-12 py-16 md:py-24 relative z-10" data-id="element-351">
          <div className="flex flex-col lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center" data-id="element-352">
            {/* Badge + Title — always first on mobile, part of left column on desktop */}
            <div className="order-1 lg:order-none text-center lg:text-left flex flex-col items-center lg:items-start mb-8 lg:mb-0 lg:row-span-1" data-id="element-353">
              <div className="inline-flex items-center gap-2 bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.08)] backdrop-blur-sm px-4 py-2 rounded-full mb-6 shadow-[0_4px_20px_rgba(0,0,0,0.2)]" data-id="element-354">
                <div className="w-2 h-2 rounded-full bg-[#3B82F6] animate-pulse" data-id="element-355"></div>
                <span className="font-['Montserrat'] text-[11px] font-bold tracking-[0.18em] uppercase text-[#3B82F6]" data-id="element-356">
                  IMPLEMENTARE SISTEME DE BUSINESS
                </span>
              </div>

              <h1 className="font-['Montserrat'] text-[clamp(32px,4.5vw,56px)] font-extrabold text-white leading-[1.1] mb-0 lg:mb-6 tracking-tight" data-id="element-357">
                Din compania care depinde de tine, la afacerea care merge fără
                tine.
              </h1>

              {/* Paragraph + CTA — hidden on mobile, shown on desktop */}
              <div className="hidden lg:block" data-id="element-358">
                <p className="font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.7)] leading-[1.8] mb-8 max-w-[600px]" data-id="element-359">
                  Vin în compania ta, lucrez alături de tine și de echipa ta de
                  lideri și implementez “PROVI System” pas cu pas, astfel încât
                  afacerea ta să producă rezultate predictibile, să crească și
                  să meargă fără implicarea ta zilnică.
                </p>

                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-6" data-id="element-360">
                  <BookingButton text="Vreau o Diagnosticare Gratuită a Companiei" data-id="element-361" />
                </div>

                <div className="flex items-start gap-3 max-w-[500px]" data-id="element-362">
                  <svg className="w-5 h-5 text-[#3B82F6] flex-shrink-0 mt-0.5 opacity-70" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-363">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-364"></path>
                  </svg>
                  <p className="font-['Inter'] text-[15px] text-[rgba(255,255,255,0.6)] leading-[1.7]" data-id="element-365">
                    Dacă muncești la fel de mult ca acum 3 ani și afacerea tot
                    nu crește, problema nu ești tu. E lipsa sistemului.
                  </p>
                </div>
              </div>
            </div>

            {/* Photo — second on mobile, right column on desktop */}
            <div className="order-2 lg:order-none relative w-full max-w-[400px] lg:max-w-[500px] mx-auto lg:ml-auto mb-8 lg:mb-0" data-id="element-366">
              {/* Large Glowing Halo Behind Photo */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[110%] h-[110%] rounded-full bg-[#1D4ED8] opacity-[0.15] blur-[60px] z-0" data-id="element-367"></div>

              {/* Animated Concentric Rings */}
              <svg className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[130%] h-[130%] z-0" viewBox="0 0 400 400" fill="none" data-id="element-368">
                <circle cx="200" cy="200" r="180" stroke="#1D4ED8" strokeWidth="1" opacity="0.2" strokeDasharray="8 6" data-id="element-369">
                  <animateTransform attributeName="transform" type="rotate" from="0 200 200" to="360 200 200" dur="60s" repeatCount="indefinite" data-id="element-370" />
                </circle>
                <circle cx="200" cy="200" r="160" stroke="#3B82F6" strokeWidth="0.5" opacity="0.15" strokeDasharray="4 8" data-id="element-371">
                  <animateTransform attributeName="transform" type="rotate" from="360 200 200" to="0 200 200" dur="45s" repeatCount="indefinite" data-id="element-372" />
                </circle>
                <circle cx="200" cy="200" r="195" stroke="#1D4ED8" strokeWidth="0.5" opacity="0.1" data-id="element-373" />
              </svg>

              <div className="relative z-10 rounded-2xl overflow-hidden border-2 border-[rgba(29,78,216,0.3)] shadow-[0_20px_60px_rgba(29,78,216,0.25),0_0_0_1px_rgba(255,255,255,0.05)] group" data-id="element-374">
                <div className="absolute inset-0 bg-gradient-to-t from-[#09111F] via-transparent to-transparent opacity-60 z-10" data-id="element-375"></div>
                <img src="https://cdn.magicpatterns.com/uploads/fWFHPTDBhfM1RiRRjS7QNx/Valer_1.jpg" alt="Valer Dura" className="w-full h-auto object-cover" data-id="element-376" />
              </div>
            </div>

            {/* Paragraph + CTA — third on mobile only */}
            <div className="order-3 lg:hidden text-center flex flex-col items-center" data-id="element-377">
              <p className="font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.7)] leading-[1.8] mb-8 max-w-[600px]" data-id="element-378">
                Vin în compania ta, lucrez alături de tine și de echipa ta de
                lideri și implementez “PROVI System” pas cu pas, astfel încât
                afacerea ta să producă rezultate predictibile, să crească și să
                meargă fără implicarea ta zilnică.
              </p>

              <div className="flex flex-col items-center gap-4 mb-6 w-full" data-id="element-379">
                <BookingButton text="Vreau o Diagnosticare Gratuită a Companiei" className="w-full sm:w-auto" data-id="element-380" />
              </div>

              <div className="flex items-start gap-3 max-w-[500px]" data-id="element-381">
                <svg className="w-5 h-5 text-[#3B82F6] flex-shrink-0 mt-0.5 opacity-70" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-382">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-383"></path>
                </svg>
                <p className="font-['Inter'] text-[15px] text-[rgba(255,255,255,0.6)] leading-[1.7]" data-id="element-384">
                  Dacă muncești la fel de mult ca acum 3 ani și afacerea tot nu
                  crește, problema nu ești tu. E lipsa sistemului.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2 — PROBLEME / DURERI */}
      <section className="w-full bg-[#F1F5F9] py-14 md:py-20 relative" data-id="element-385">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12 relative z-10" data-id="element-386">
          <div className="text-center max-w-[800px] mx-auto mb-16" data-id="element-387">
            <h2 className="font-['Montserrat'] text-[clamp(28px,4vw,40px)] font-bold text-[#09111F] mb-4 tracking-tight" data-id="element-388">
              Recunoști cel puțin una din aceste situații în compania ta?
            </h2>
            <div className="w-16 h-1 bg-[#1D4ED8] mx-auto rounded-full" data-id="element-389"></div>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-390">
            {/* Card 1 */}
            <div className="bg-white border border-[rgba(0,0,0,0.04)] border-l-4 border-l-[#1D4ED8] rounded-2xl p-8 relative overflow-hidden group hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)] transition-all duration-300 hover:-translate-y-1" data-id="element-391">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-[#EFF6FF] to-transparent rounded-bl-full -z-10 opacity-50 group-hover:opacity-100 transition-opacity duration-300" data-id="element-392"></div>
              <div className="w-14 h-14 bg-[#EFF6FF] text-[#1D4ED8] rounded-xl flex items-center justify-center mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-393">
                <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-394">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-395"></path>
                </svg>
              </div>
              <div className="mb-5" data-id="element-396">
                <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#09111F] mb-2" data-id="element-397">
                  CAPTIVITATE
                </h3>
                <div className="inline-block bg-[#F1F5F9] px-3 py-1 rounded-md" data-id="element-398">
                  <p className="font-['Montserrat'] text-[10px] font-bold tracking-[0.1em] uppercase text-[#6B7280]" data-id="element-399">
                    EPUIZARE . CONTROL . NON-STOP ÎN OPERAȚIONAL
                  </p>
                </div>
              </div>
              <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-400">
                Ești cel mai ocupat om din firmă ta. Faci vânzări, rezolvi
                probleme, iei decizii, gestionezi oameni și tot nu e suficient.
                Dacă pleci două săptămâni, totul se blochează. Ai construit o
                afacere care, în realitate, te deține pe tine.
              </p>
            </div>

            {/* Card 2 */}
            <div className="bg-white border border-[rgba(0,0,0,0.04)] border-l-4 border-l-[#3B82F6] rounded-2xl p-8 relative overflow-hidden group hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)] transition-all duration-300 hover:-translate-y-1" data-id="element-401">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-[#EFF6FF] to-transparent rounded-bl-full -z-10 opacity-50 group-hover:opacity-100 transition-opacity duration-300" data-id="element-402"></div>
              <div className="w-14 h-14 bg-[#EFF6FF] text-[#3B82F6] rounded-xl flex items-center justify-center mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-403">
                <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-404">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" data-id="element-405"></path>
                </svg>
              </div>
              <div className="mb-5" data-id="element-406">
                <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#09111F] mb-2" data-id="element-407">
                  PLAFONARE
                </h3>
                <div className="inline-block bg-[#F1F5F9] px-3 py-1 rounded-md" data-id="element-408">
                  <p className="font-['Montserrat'] text-[10px] font-bold tracking-[0.1em] uppercase text-[#6B7280]" data-id="element-409">
                    STAGNARE . FĂRĂ DIRECȚIE . ECHIPĂ CONFUZĂ
                  </p>
                </div>
              </div>
              <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-410">
                Muncești la fel de mult ca acum câțiva ani, dar cifra nu mai
                crește. Echipa nu știe exact ce are de făcut fără tine. Nu
                există o viziune clară pe care toată lumea să o urmeze. Simți că
                dai în gol și nu înțelegi de ce.
              </p>
            </div>

            {/* Card 3 */}
            <div className="bg-white border border-[rgba(0,0,0,0.04)] border-l-4 border-l-[#0A1628] rounded-2xl p-8 relative overflow-hidden group hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)] transition-all duration-300 hover:-translate-y-1" data-id="element-411">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-[#F1F5F9] to-transparent rounded-bl-full -z-10 opacity-50 group-hover:opacity-100 transition-opacity duration-300" data-id="element-412"></div>
              <div className="w-14 h-14 bg-[#F1F5F9] text-[#0A1628] rounded-xl flex items-center justify-center mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-413">
                <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-414">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" data-id="element-415"></path>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 8l-4 4m0 0l-4-4m4 4v8" data-id="element-416"></path>
                </svg>
              </div>
              <div className="mb-5" data-id="element-417">
                <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#09111F] mb-2" data-id="element-418">
                  HAOS
                </h3>
                <div className="inline-block bg-[#F1F5F9] px-3 py-1 rounded-md" data-id="element-419">
                  <p className="font-['Montserrat'] text-[10px] font-bold tracking-[0.1em] uppercase text-[#6B7280]" data-id="element-420">
                    IMPROVIZAȚIE . FĂRĂ PROCESE . DUPĂ URECHE
                  </p>
                </div>
              </div>
              <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-421">
                Lucrurile se fac, dar nu se fac la fel de fiecare dată. Nu
                există procese clare, nu există roluri definite, nu există
                KPI-uri pe care echipa să le urmărească. Totul depinde de
                implicarea ta sau de cheful fiecărui angajat. Asta nu e o
                companie. E un șantier permanent.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 3 — METODA / CONCEPTUL UNIC */}
      <section className="w-full bg-white py-14 md:py-20 overflow-hidden" data-id="element-422">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-423">
          <div className="text-center mb-16 md:mb-24" data-id="element-424">
            <h2 className="font-['Montserrat'] text-[clamp(28px,4vw,40px)] font-bold text-[#09111F] mb-6 tracking-tight" data-id="element-425">
              PROVI System: Cele 8 componente ale unei afaceri care merge fără
              tine
            </h2>
            <p className="font-['Inter'] text-[19px] font-light text-[#6B7280] leading-[1.8] max-w-[720px] mx-auto" data-id="element-426">
              Tocmai din acest motiv am construit sistemul unic de conducere
              antreprenorială construit să fie implementat pas cu pas, direct în
              compania ta, de o echipă de specialiști, până când afacerea ta
              funcționează singură.
            </p>
          </div>

          <ProviInfographic data-id="element-427" />

          {/* 4 Piloni principali (Summary) */}
          <div className="grid md:grid-cols-2 gap-6 relative z-10" data-id="element-428">
            <div className="bg-white border border-[rgba(0,0,0,0.04)] rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300" data-id="element-429">
              <div className="flex items-center gap-4 mb-5" data-id="element-430">
                <div className="w-12 h-12 bg-[#EFF6FF] rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-431">
                  <svg className="w-6 h-6 text-[#1D4ED8]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-432">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" data-id="element-433"></path>
                  </svg>
                </div>
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#09111F]" data-id="element-434">
                  Viziune & Strategie
                </h3>
              </div>
              <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-435">
                Construim împreună direcția clară a companiei pe 1, 3 ani și 10
                ani, planul concret care o face reală. Echipa ta va știi exact
                unde merge compania și va fi motivata sa ia acțiunile sa ajungă
                acolo.
              </p>
            </div>

            <div className="bg-white border border-[rgba(0,0,0,0.04)] rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300" data-id="element-436">
              <div className="flex items-center gap-4 mb-5" data-id="element-437">
                <div className="w-12 h-12 bg-[#EFF6FF] rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-438">
                  <svg className="w-6 h-6 text-[#1D4ED8]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-439">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" data-id="element-440"></path>
                  </svg>
                </div>
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#09111F]" data-id="element-441">
                  Oameni & Roluri
                </h3>
              </div>
              <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-442">
                Definim organigrama funcțională, fișele de rol clare și matricea
                de responsabilități. Fiecare om din echipă știe ce are de făcut,
                față de cine răspunde și cum e măsurat.
              </p>
            </div>

            <div className="bg-white border border-[rgba(0,0,0,0.04)] rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300" data-id="element-443">
              <div className="flex items-center gap-4 mb-5" data-id="element-444">
                <div className="w-12 h-12 bg-[#EFF6FF] rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-445">
                  <svg className="w-6 h-6 text-[#1D4ED8]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-446">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" data-id="element-447"></path>
                  </svg>
                </div>
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#09111F]" data-id="element-448">
                  Numere & KPI
                </h3>
              </div>
              <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-449">
                Construim un tablou de bord simplu, cu indicatorii care contează
                cu adevărat. Afacerea ta va fi condusă pe cifre reale, nu pe
                impresii sau după ureche. În acest fel poți anticipa probleme
                înainte ca acestea sa escaladeze.
              </p>
            </div>

            <div className="bg-white border border-[rgba(0,0,0,0.04)] rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300" data-id="element-450">
              <div className="flex items-center gap-4 mb-5" data-id="element-451">
                <div className="w-12 h-12 bg-[#EFF6FF] rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-452">
                  <svg className="w-6 h-6 text-[#1D4ED8]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-453">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" data-id="element-454"></path>
                  </svg>
                </div>
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#09111F]" data-id="element-455">
                  Procese & Progres
                </h3>
              </div>
              <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-456">
                Documentăm procesele critice și implementăm sistemul de
                follow-up săptămânal. Orice angajat nou va putea performa în
                timp scurt. Compania produce rezultate constant, nu doar când
                ești tu prezent.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4 — DESPRE MINE */}
      <section className="w-full bg-[#0A1628] py-14 md:py-20 relative overflow-hidden" data-id="element-457">
        <div className="absolute inset-0 opacity-[0.02] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-458"></div>
        <div className="max-w-[1200px] mx-auto px-5 md:px-12 relative z-10" data-id="element-459">
          <div className="grid md:grid-cols-[500px_1fr] gap-10 md:gap-14 items-stretch" data-id="element-460">
            <div className="relative w-full max-w-[500px] mx-auto self-stretch" data-id="element-461">
              <div className="relative z-10 rounded-2xl overflow-hidden border-2 border-[rgba(255,255,255,0.1)] shadow-[0_20px_60px_rgba(0,0,0,0.5)] h-full min-h-[500px]" data-id="element-462">
                <img src="https://cdn.magicpatterns.com/uploads/iBEbtRXUbrUYaPC1MiruXn/Valer_tabala.jpg" alt="Valer Dura" className="w-full h-full object-cover object-[70%_20%]" data-id="element-463" />
              </div>
            </div>
            <div className="relative flex flex-col justify-center" data-id="element-464">
              <h2 className="font-['Montserrat'] text-[clamp(32px,4vw,44px)] font-bold text-white mb-3 tracking-tight" data-id="element-465">
                Valer Dura
              </h2>
              <p className="font-['Montserrat'] text-[16px] font-semibold text-[#3B82F6] mb-6" data-id="element-466">
                Arhitect de Sisteme Antreprenoriale Scalabile & Vandabile
                <br data-id="element-467" />
                Fondator PROVI System
              </p>
              <div className="space-y-4 font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.75)] leading-[1.8] mb-10" data-id="element-468">
                <p data-id="element-469">
                  Sunt Valer Dura și lucrez cu antreprenori mici și mijlocii
                  care au construit o afacere ce funcționează, dar nu
                  funcționează fără ei. Am 12 ani de experiență în implementarea
                  sistemelor de conducere pentru companii românești, am
                  construit și vândut afaceri cu cifre de milioane de euro și
                  știu din interior cum arată o companie care ajunge la nivelul
                  la care fondatorul are libertate, timp și bani.
                </p>
                <p data-id="element-470">
                  Prin PROVI System, implementez în compania ta cele 8
                  componente esențiale ale unui business sistematizat: de la
                  viziune și structură de echipă, la KPI-uri, procese, follow-up
                  săptămânal și management financiar. Nu predau teorie. Vin cu
                  echipa mea de implementatori, lucrăm direct cu liderii tăi și
                  construim sistemul de la zero până la funcțional.
                </p>
                <p className="text-white font-medium" data-id="element-471">
                  Rezultatul nu e un dosar cu recomandări. E o companie care
                  produce rezultate fără ca tu să fii prezent în fiecare zi.
                </p>
              </div>

              <div className="bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.06)] backdrop-blur-xl rounded-2xl p-6" data-id="element-472">
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-white mb-5" data-id="element-473">
                  Misiunea mea
                </h3>
                <div className="space-y-3" data-id="element-474">
                  <div className="flex items-start gap-3 bg-[rgba(255,255,255,0.02)] border border-[rgba(255,255,255,0.04)] rounded-xl p-4" data-id="element-475">
                    <p className="font-['Inter'] text-[17px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6]" data-id="element-476">
                      Din antreprenor captiv în propria firmă, la{' '}
                      <strong className="text-white font-medium" data-id="element-477">
                        fondator liber
                      </strong>
                      .
                    </p>
                  </div>
                  <div className="flex items-start gap-3 bg-[rgba(255,255,255,0.02)] border border-[rgba(255,255,255,0.04)] rounded-xl p-4" data-id="element-478">
                    <p className="font-['Inter'] text-[17px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6]" data-id="element-479">
                      Din companie dependentă de om, la{' '}
                      <strong className="text-white font-medium" data-id="element-480">
                        sistem care funcționează singur
                      </strong>
                      .
                    </p>
                  </div>
                  <div className="flex items-start gap-3 bg-[rgba(255,255,255,0.02)] border border-[rgba(255,255,255,0.04)] rounded-xl p-4" data-id="element-481">
                    <p className="font-['Inter'] text-[17px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6]" data-id="element-482">
                      Din stagnare și plafonare, la{' '}
                      <strong className="text-white font-medium" data-id="element-483">
                        creștere predictibilă și garantată
                      </strong>
                      .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 5 — MODALITĂȚI DE A LUCRA CU MINE */}
      <section className="w-full bg-[#F1F5F9] py-14 md:py-20 relative z-10" data-id="element-484">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12 relative z-10" data-id="element-485">
          <div className="text-center max-w-[700px] mx-auto mb-16" data-id="element-486">
            <h2 className="font-['Montserrat'] text-[clamp(28px,4vw,40px)] font-bold text-[#09111F] mb-4 tracking-tight" data-id="element-487">
              Cum poți lucra cu mine
            </h2>
            <p className="font-['Inter'] text-[19px] font-light text-[#6B7280] leading-[1.8]" data-id="element-488">
              Alege punctul de intrare potrivit pentru situația companiei tale.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8" data-id="element-489">
            <OfferCard title="Implementare PROVI System" subtitle="Vin în compania ta și construim totul împreună" benefits={['Implementare completă a celor 8 componente PROVI, pas cu pas', 'Lucrez direct cu tine și cu echipa ta de lideri, nu predau teorie', 'Echipă de specialiști pe departamente: financiar, HR, procese, automatizare', 'Sesiuni săptămânale, lunare și trimestriale de progres și corecție', 'La final, compania ta funcționează predictibil, cu sau fără tine']} buttonText="Vreau să Implementăm PROVI în Compania Mea" buttonHref="/provisystem" isPrimary={true} data-id="element-490" />
            <OfferCard title="Diagnostic PROVI" subtitle="Evaluare personalizată a companiei tale, 1 la 1" benefits={['Analizăm împreună toate departamentele companiei tale', 'Identificăm blocajele reale care te țin pe loc acum', 'Primești harta exactă a priorităților de implementare', 'Înțelegi ce anume oprește creșterea, în termeni clari, fără jargon', 'Primul pas înainte de orice implementare']} buttonText="Vreau Diagnosticarea Companiei Mele" buttonHref="https://calendly.com/valerdura-coaching/sesiune-descoperire" data-id="element-491" />
            <OfferCard title="Workshop Intensiv" subtitle="2 zile de lucru concret cu echipa ta" benefits={['Lucrăm intensiv pe un blocaj specific sau pe strategia anuală', 'Antreprenor plus echipă de lideri, în același timp, în aceeași sală', 'Ieși cu planul clar, asumat și gata de implementat', 'Format concentrat, fără timp pierdut, cu rezultat concret la final', 'Potrivit când ai nevoie de claritate rapid, nu de implementare lungă']} buttonText="Vreau un Workshop Intensiv" buttonHref="/contact" data-id="element-492" />
          </div>
        </div>
      </section>

      {/* SECTION 6 — DIAGNOSTIC CADOU */}
      <section className="w-full bg-[#09111F] py-16 md:py-24 relative overflow-hidden" data-id="element-493">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12 relative z-10" data-id="element-494">
          <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-495">
            {/* Left: B&W Image */}
            <div className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-496">
              <div className="absolute inset-0 bg-[#1D4ED8]/20 mix-blend-overlay z-10" data-id="element-497"></div>
              <img src="https://cdn.magicpatterns.com/uploads/fWFHPTDBhfM1RiRRjS7QNx/Valer_1.jpg" alt="Valer Dura - Sesiune de Diagnoză" className="w-full h-auto object-cover grayscale" data-id="element-498" />
            </div>

            {/* Right: Content */}
            <div className="text-left" data-id="element-499">
              <div className="inline-flex items-center gap-2 bg-[rgba(29,78,216,0.15)] border border-[rgba(29,78,216,0.3)] px-4 py-2 rounded-full mb-8" data-id="element-500">
                <span className="font-['Montserrat'] text-[11px] font-bold tracking-[0.18em] uppercase text-[#3B82F6]" data-id="element-501">
                  SESIUNE CADOU DE DIAGNOZĂ
                </span>
              </div>
              <h2 className="font-['Montserrat'] text-[clamp(28px,4vw,40px)] font-bold text-white mb-6 tracking-tight leading-[1.15]" data-id="element-502">
                Află în 60 de minute ce oprește creșterea companiei tale
              </h2>
              <p className="font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.75)] leading-[1.8] mb-10" data-id="element-503">
                Rezervă o sesiune de diagnostic CADOU cu mine. Analizăm împreună
                situația reală a afacerii tale și îți spun exact ce lipsește, în
                ce ordine trebuie rezolvat și cum arată primul pas concret spre
                o companie care merge fără tine.
              </p>
              <BookingButton text="Rezervă Sesiunea de Diagnoză Cadou" className="w-full sm:w-auto px-8 py-4 text-[16px]" data-id="element-504" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7 — TESTIMONIALE */}
      <section className="w-full bg-[#F1F5F9] py-14 md:py-20 relative" data-id="element-505">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12 relative z-10" data-id="element-506">
          <div className="text-center max-w-[800px] mx-auto mb-16" data-id="element-507">
            <h2 className="font-['Montserrat'] text-[clamp(28px,4vw,40px)] font-bold text-[#09111F] mb-4 tracking-tight" data-id="element-508">
              Ce spun antreprenorii care au implementat PROVI System
            </h2>
            <div className="w-16 h-1 bg-[#1D4ED8] mx-auto rounded-full" data-id="element-509"></div>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-510">
            {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-511" />)}
          </div>
        </div>
      </section>

      {/* SECTION 8 — FOOTER CTA */}
      <FooterCTA data-id="element-512" />
    </div>;
}